// extracted by mini-css-extract-plugin
module.exports = {"gridSection":"GridModal_gridSection__3BX4z"};